import React from 'react';
import { Link } from 'react-router';
import {
  TextField,
  Box,
  Alert,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';

import { getImageType } from './utils';
import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function CustomImageField({
  value,
  onChange,
  onErrorChange,
  edit,
}) {
  const project_credentials = useSelector((state) => state.projectCredentials);
  const safeValue = value ?? '';

  const handleChange = (event) => {
    const new_value = event.target.value ?? '';
    const type = getImageType(new_value);
    const custom_image_type_error = Boolean(
      type &&
        project_credentials != null &&
        !project_credentials.some((key) => key.type === type)
    );
    const custom_image_error = Boolean(!type && new_value !== '');

    onChange(new_value);
    onErrorChange({
      custom_image_error,
      custom_image_type: type,
      custom_image_type_error,
    });
  };

  const image_type = getImageType(safeValue);
  const has_type_error =
    image_type &&
    project_credentials != null &&
    !project_credentials.some((key) => key.type === image_type);
  const has_validation_error = Boolean(!image_type && safeValue !== '');

  return (
    <Box>
      <TextField
        fullWidth
        label='Image'
        value={safeValue}
        onChange={handleChange}
        disabled={edit}
        error={has_validation_error}
        helperText={
          has_validation_error
            ? 'Unable to determine image registry type'
            : undefined
        }
      />
      {has_type_error ? (
        <Alert
          severity={image_type === THIRD_PARTY_TYPES.DOCKER.value ? 'warning' : 'error'}
          sx={{ mt: 2 }}
        >
          <Typography variant='h6'>
            {image_type === THIRD_PARTY_TYPES.DOCKER.value
              ? 'Warning'
              : 'Error'}
          </Typography>
          <Typography>
            A{' '}
            <Link to='/account/settings' target='_blank'>
              Third Party Key
            </Link>{' '}
            is not configured for image registry provider <b>{image_type}</b>.
          </Typography>
          {image_type === THIRD_PARTY_TYPES.DOCKER.value ? (
            <Typography sx={{ mt: 1 }}>
              Private repositories images will fail and pulls from public
              repositories may be{' '}
              <a
                href='https://www.docker.com/increase-rate-limits'
                target='_blank'
                rel='noreferrer'
              >
                rate limited
              </a>{' '}
              or error.
            </Typography>
          ) : undefined}
        </Alert>
      ) : undefined}
    </Box>
  );
}

